// Rótulo de quien abrió su cuenta PCF en la tienda y aún no compra; lo usan las tablas de clientes.
export const ACCOUNT_ONLY_LABEL = 'Solo cuenta';
